"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderComponentsViewerAndReturnUnmount = void 0;
var utils_1 = require("../utils");
var components_viewer_comp_1 = require("./components-viewer.comp");
function renderComponentsViewerAndReturnUnmount(elem, locale, components, onImgClick) {
    var compProps = { locale: locale, components: components, onImgClick: onImgClick };
    return utils_1.renderCompAndReturnUnmount(elem, components_viewer_comp_1.ComponentsViewer, compProps);
}
exports.renderComponentsViewerAndReturnUnmount = renderComponentsViewerAndReturnUnmount;
//# sourceMappingURL=components-viewer-renderer.js.map